export const getFanclubWizardRoute = () => '/fanclub-wizard';